import React, { useState } from "react";
import { FileText, X, AlertTriangle, Camera, Loader } from "lucide-react";
import ReactDOM from "react-dom";
import { useFile } from "../context/filecontext";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;
const formatMeasurement = (value, unit) => {
  if (value == 0) return "---";
  return value ? `${Number(value).toFixed(2)} ${unit}` : "---";
};

const generateUniqueId = (stopename) => {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = now.getFullYear();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  const formattedDate = `${day}_${month}_${year}`;
  const formattedTime = `${hours}${minutes}${seconds}`;
  const shortname = stopename ? stopename.substring(0, 3).toUpperCase() : "XXX";
  const stopecode = shortname + "_" + formattedDate + "_" + formattedTime;
  return stopecode;
};

const formatDate = (date) => {
  return date.toISOString().split("T")[0];
};

const SaveModel = ({ isOpen, onClose, measurements, viewer }) => {
  const [formData, setFormData] = useState({
    stopeName: "",
    stopeCode: generateUniqueId(),
    stopeAnalysisDate: "",
    scanFileLocation: "",
    planFileLocation: "",
    scanResult: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [scanResult, setScanResult] = useState("");
  const [stopeCode, setStopeCode] = useState("");
  const {
    metadataUrl,
    clearMetadataUrl,
    uploadResponseData,
    updateUploadResponseData,
    showNotificationWithConfig,
    designLasUrl,
    setDesignLasUrl,
  } = useFile();
  let gStates = useFile();
  console.log(gStates, "gStates");
  const saveStopeDetails = async (
    { file_id, volume, metadata_url, octree_url },
    name,
    scancode
  ) => {
    const scanFileData = {
      actualFileURL: metadata_url,
      fileId: file_id,
      octreeURL: octree_url,
    };
    setScanResult(
      JSON.stringify(
        localStorage.getItem("scanresult")
          ? JSON.parse(localStorage.getItem("scanresult"))
          : ""
      )
    );
    setStopeCode(scancode);

    let data = {
      bimsuid: 0,
      blastopeid: 0,
      companyid: "c3VzaGls",
      levelcode: 0,
      minecode: 0,
      planfilelocation: JSON.stringify(
        localStorage.getItem("planfilelocation")
          ? JSON.parse(localStorage.getItem("planfilelocation"))
          : ""
      ),
      rockcode: 0,
      scancode: scancode,
      scandatetime: formData.stopeAnalysisDate,
      scanfilelocation: JSON.stringify(scanFileData),
      scanid: localStorage.getItem("scanid")
        ? Number(localStorage.getItem("scanid"))
        : 0,
      scanname: name,
      scanresult: JSON.stringify(
        localStorage.getItem("scanresult")
          ? JSON.parse(localStorage.getItem("scanresult"))
          : ""
      ),
      stopecode: 0,
      userid: "c3VzaGls",
    };
    console.log(data);
    try {
      const response = await axios.post(
        API_BASE_URL + "/stopescannedresultinsertupdate",
        data,
        {
          header: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      if (response.status === 200 || response.status === 201) {
        showNotificationWithConfig({
          type: "success",
          message: "Successful: Data saved!",
          duration: 3000,
        });
      } else {
        showNotificationWithConfig({
          type: "error",
          message: "Something went wrong!",
          duration: 3000,
        });
      }
      data.scanid = response.data.id ? response.data.id : data.scanid;
      localStorage.setItem("scanid", data.scanid);
      localStorage.setItem("stopedata", JSON.stringify(data));
      window.apiData = data;
      setIsLoading(false);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    const fileUploadData = {
      file_id: gStates.uploadResponseData.file_id,
      volume: gStates.uploadResponseData.volume,
      metadata_url: gStates.uploadResponseData.metadata_url,
      octree_url: gStates.uploadResponseData.octree_url,
    };
    await saveStopeDetails(
      fileUploadData,
      formData.stopeName,
      formData.stopeCode
    );
    onClose(true);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black/50" onClick={onClose} />

      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative w-full max-w-3xl bg-white rounded-lg shadow-xl">
          <div className="relative p-6">
            <button
              onClick={onClose}
              className="absolute right-4 top-4 text-gray-400 hover:text-gray-500"
            >
              <X className="h-5 w-5" />
            </button>

            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-900">
                Stope Analysis Information
              </h3>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Project Details */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Stope Code
                  </label>
                  <input
                    type="text"
                    value={generateUniqueId(formData.stopeName)}
                    readOnly
                    onChange={(e) =>
                      setFormData({ ...formData, stopeCode: e.target.value })
                    }
                    className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm"
                    placeholder="Enter Stope Code"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Stope Name
                  </label>
                  <input
                    type="text"
                    value={formData.stopeName}
                    onChange={(e) => {
                      const newStopeName = e.target.value;
                      setFormData({
                        ...formData,
                        stopeName: newStopeName,
                        stopeCode: generateUniqueId(newStopeName), // Update stopeCode dynamically
                      });
                    }}
                    className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm"
                    placeholder="Enter Stope Name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Stope Analysis Date
                  </label>
                  <input
                    type="date"
                    value={formData.stopeAnalysisDate}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        stopeAnalysisDate: e.target.value,
                      })
                    }
                    className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm"
                    placeholder="Enter surveyor name"
                  />
                </div>
              </div>

              {/* Current Measurements Preview */}
              <div className="bg-gray-50 rounded-lg p-4">
                <h4 className="text-sm font-medium text-gray-700 mb-3">
                  Analysis Result
                </h4>
                <div className="grid grid-cols-3 gap-4">
                  <div className="space-y-2">
                    <h5 className="text-xs font-medium text-gray-500">
                      Volume Analysis
                    </h5>
                    <div className="text-sm">
                      <div>
                        Planned Volume:{" "}
                        {measurements.plannedDesignVolume.volume} m³
                      </div>
                      <div>
                        Actual Volume:{" "}
                        {measurements.volume.totalVolume.toFixed(2)} m³
                      </div>
                      {/* <div>Surface Area: {formatMeasurement(measurements?.volume?.surfaceArea, 'm²')}</div> */}
                    </div>
                  </div>
                  <div className="space-y-2">
                    <h5 className="text-xs font-medium text-gray-500">
                      Overbreak
                    </h5>
                    <div className="text-sm">
                      <div>Volume: {measurements.overbreak.volume} m³</div>
                      <div>
                        Percentage: {measurements.overbreak.percentage} %
                      </div>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <h5 className="text-xs font-medium text-gray-500">
                      Underbreak
                    </h5>
                    <div className="text-sm">
                      <div>Volume: {measurements.underbreak.volume} m³</div>
                      <div>
                        Percentage: {measurements.underbreak.percentage} %
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Error Message */}
              {error && (
                <div className="flex items-center gap-2 text-red-600 text-sm">
                  <AlertTriangle className="h-4 w-4" />
                  <span>{error}</span>
                </div>
              )}

              {/* Form Actions */}
              <div className="flex justify-end gap-3">
                <button
                  type="button"
                  onClick={onClose}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`flex items-center px-4 py-2 text-sm font-medium text-white rounded-md
                        ${
                          isLoading
                            ? "bg-blue-400"
                            : "bg-blue-600 hover:bg-blue-700"
                        }`}
                >
                  {isLoading ? (
                    <>
                      <Loader className="w-4 h-4 mr-2 animate-spin" />
                      Saving...
                    </>
                  ) : (
                    <>
                      <FileText className="w-4 h-4 mr-2" />
                      Save
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>

          {/* Preview Panel */}
        </div>
      </div>
    </div>
  );
};

export default SaveModel;
